// extracted by mini-css-extract-plugin
module.exports = {"prompt":"style_prompt__MjsFc"};